import { EnvVariables, isLocal } from 'src/constants'
import { useIsInIFrame } from 'src/hooks/use-is-in-iframe'

export const useIsIntercomEnabled = () => {
  const isInIFrame = useIsInIFrame()
  return (
    !!EnvVariables.IntercomAppId &&
    !isLocal() &&
    // we show the routes.chat page when we embed the chat widget in another website (i.e. a .gov website)
    // so we don't want to show the intercom widget on that other website's page
    !isInIFrame
  )
}
